//
import React, { useEffect, useState } from 'react';
import { Alert, Dimensions, FlatList, StyleSheet, Text, View } from 'react-native';
import { Button as PaperButton, Dialog } from 'react-native-paper';
import clienteApi from '../../apis/clienteApi';
import colors from '../../colors';
import { TXT_M } from '../../constants';
import { useUpdateEffect } from '../../helper';
import { useSessaoOnly } from '../../redux/sessao/sessaoHooks';
import Cliente from '../../shared/entity/Cliente';
import { EdLike, FindManyReq } from '../../shared/types/TypeormTypes';
import FormCadastro from '../CadastroPage/FormCadastro';
import Button from '../Generic/Button';
import CModal from '../Generic/CModal';
import CTextInput from '../Generic/CTextInput';
import Divider from '../Generic/Divider';
import Title from '../Generic/Title';
import Touchable from '../Generic/Touchable';
import ItemSelecaoCliente from './ItemSelecaoCliente';

const DEVICE_WIDTH = Dimensions.get('window').width;
const DEVICE_HEIGHT = Dimensions.get('window').height;

type Props = {
  cliente?: Cliente;
  setCliente: (x: Cliente) => void;
};

const SelecaoCliente: React.FC<Props> = (props) => {
  const { cliente, setCliente } = props;

  const [loading, setLoading] = useState(true);
  const [clientes, setClientes] = useState<Cliente[]>([]);
  // const indexSelecionado = cliente ? clientes.findIndex((item) => item.id === cliente.id) : null;

  const [totalLinhas, setTotalLinhas] = useState(0);
  const [query, setQuery] = useState<FindManyReq<Cliente>>({});
  const [pagina, setPagina] = useState(0);
  const linhasPorPagina = 10;

  const [sessao] = useSessaoOnly();

  const [nomeCliente, setNomeCliente] = useState('');
  const [celularCliente, setCelularCliente] = useState('');

  const [modalSelecionarCliente, setModalSelecionarCliente] = useState(false);
  const [modalAddCliente, setModalAddCliente] = useState(false);

  useUpdateEffect(() => {
    getClientes();
  }, [query, pagina]);

  useEffect(() => {
    buscar();
  }, []);

  const getClientes = async () => {
    const isAdmin = sessao.cliente && sessao.cliente.nivel > 0;
    if (!query || !isAdmin) {
      return;
    }
    try {
      query.skip = pagina * linhasPorPagina;
      query.take = linhasPorPagina;
      let clientes = await clienteApi.getMany(query);
      console.log('clientes', clientes);

      setClientes(clientes);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Alert.alert('Erro!', `Ocorreu um erro ao buscar os clientes. ${error.data}`);
    }
  };

  const buscar = async () => {
    console.log('buscar');

    const isAdmin = sessao.cliente && sessao.cliente.nivel > 0;
    if (!isAdmin) {
      return;
    }

    let query: FindManyReq<Cliente> = {
      relations: ['enderecos']
    };
    query.where = {};

    if (nomeCliente) {
      query.where.nome = EdLike(`%${nomeCliente}%`);
    }
    if (celularCliente) {
      query.where.celular = EdLike(`%${celularCliente}%`);
    }

    try {
      let totalLinhas = await clienteApi.count(query);
      setQuery(query);
      setTotalLinhas(totalLinhas);
      setPagina(0);
    } catch (error) {
      setLoading(false);
      Alert.alert('Erro!', `Ocorreu um erro ao buscar os clientes. ${error.data}`);
    }
  };
  // const salvarNovoCliente = async () => {
  //   try {
  //     const response = await clienteApi.insert(novoCliente);
  //     await buscarClientes();
  //     setCliente(response);
  //   } catch (err) {
  //     Alert.alert('Erro', err.data ?? 'Erro ao cadastrar cliente.');
  //   }
  // };

  if (!sessao.token) {
    return null;
  }

  return (
    <View>
      <CModal
        mostrarModal={modalSelecionarCliente}
        onClose={() => setModalSelecionarCliente(false)}
      >
        <Dialog.Content>
          <View style={styles.header}>
            <Title>Buscar Cliente</Title>
            <Button
              title={'NOVO'}
              onPress={() => setModalAddCliente(true)}
              style={{ width: 80, height: 30, marginBottom: 10 }}
              labelStyle={{ fontSize: 14 }}
            />
          </View>
          <CTextInput
            placeholder={'Nome'}
            style={{ marginBottom: 15 }}
            onChangeText={setNomeCliente}
            value={nomeCliente}
          />
          <CTextInput
            placeholder={'Celular'}
            style={{ marginBottom: 15 }}
            onChangeText={(txt) => {
              txt = txt.replace(/\D/g, '');
              setCelularCliente(txt);
            }}
            value={celularCliente}
          />

          <Button title={'BUSCAR'} onPress={() => buscar()} backgroundColor={colors.green} />
        </Dialog.Content>

        <FlatList
          data={clientes}
          keyExtractor={(item, index) => item.id.toString()}
          keyboardShouldPersistTaps={'always'}
          contentContainerStyle={{ paddingHorizontal: 20 }}
          renderItem={(obj) => {
            const cli = obj.item;
            return (
              <ItemSelecaoCliente
                cliente={cli}
                onClick={(c) => {
                  setCliente(c);
                  setModalSelecionarCliente(false);
                }}
              />
            );
          }}
        />

        <Dialog.Actions style={{ justifyContent: 'space-around' }}>
          <PaperButton onPress={() => setModalSelecionarCliente(false)} mode={'text'}>
            Cancelar
          </PaperButton>
        </Dialog.Actions>
      </CModal>

      <CModal
        mostrarModal={modalAddCliente}
        onClose={() => setModalAddCliente(false)}
        style={{ padding: 25 }}
      >
        <FormCadastro
          onCadastro={(novoCli) => {
            setCliente(novoCli);
            setModalSelecionarCliente(false);
            setModalAddCliente(false);
          }}
          preCadastro
        />
      </CModal>

      <Title style={{ marginBottom: 10 }}>Cliente:</Title>

      {/* <View style={styles.selectView}>
        <Picker
          style={styles.select}
          selectedValue={indexSelecionado}
          onValueChange={(index) => {
            setCliente(clientes[index]);
          }}
        >
          <Picker.Item label="Clique para selecionar" value={null} />
          {clientes.map((item, index) => (
            <Picker.Item label={item.nome} value={index} />
          ))}
        </Picker>
      </View> */}

      {/* <Button onPress={() => setMostrarModal(true)} title={'+ NOVA COMANDA'}></Button> */}

      <Touchable style={styles.selectView} onPress={() => setModalSelecionarCliente(true)}>
        <Text style={styles.value}>{cliente ? cliente.nome : 'Clique para selecionar'}</Text>
      </Touchable>

      <Divider style={{ marginBottom: 10, marginTop: 10 }} />
    </View>
  );
};

const styles = StyleSheet.create({
  radioLabel: {
    fontSize: TXT_M,
    color: colors.darkGrey
  },
  viewTaxa: {
    flexDirection: 'row',
    alignSelf: 'center',
    marginTop: 15,
    justifyContent: 'center',
    alignItems: 'center'
  },
  labelTaxa: { marginRight: 5, fontSize: TXT_M, color: colors.primary },
  valorTaxa: { fontSize: TXT_M, color: colors.values },

  selectView: {
    borderWidth: 2,
    borderColor: colors.lightGrey,
    borderRadius: 5,
    padding: 10
  },
  select: {
    borderWidth: 0,
    padding: 5
    // backgroundColor: '#ff0'
    // WebkitAppearance: 'none',
    // '-moz-appearance': none,
    // textIndent: 1
    // // text-overflow: '',
  },
  value: {
    fontSize: TXT_M
  },

  itemResposta: {
    borderWidth: 1,
    borderColor: colors.lightGrey,
    borderRadius: 5,
    padding: 10,
    marginBottom: 10
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between'
    // flex: 1
    // width: '100%',
    // marginBottom: 15
  }
});

export default SelecaoCliente;
